import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import $ from 'jquery';
import Env from '../model/Env';
import {FormRecommend} from '../model/Helper';

class ThankYouContractForm extends Component {

    constructor(props) {
        super(props);
        //console.log(props)
        this.state = {
            fullname: (typeof this.props.fullname === "undefined") ? "there" : this.props.fullname,
            destinationEmail: (typeof this.props.destinationEmail === "undefined") ? null : this.props.destinationEmail,
            dn: (typeof this.props.dn === "undefined") ? null : this.props.dn,
            filename: (typeof this.props.filename === "undefined") ? null : this.props.filename,
            fallback: this.props.fallback,
            details: this.props.details,
            recommend: FormRecommend(this.props.details.seller || this.props.details.mortgagor || [], this.props.details.buyer || this.props.details.mortgagee || []) 
        }
    }

    componentWillMount() {
        if(!this.state.filename) {
            if(localStorage.getItem("premium-dl")){
                this.setState({filename : localStorage.getItem("premium-dl")});
            } else {
                this.props.history.push(this.state.fallback);
            }
            //console.log("premium dl", localStorage.getItem("premium-dl"));
            //console.log("state filename", this.state.filename);
        }

        if(process.env.NODE_ENV==="development"){

        } else {
            localStorage.clear();
        }
    }

    download() {
        let filename = this.state.filename;
        if(filename) {
            $.get(Env.BASE_PDF+"/"+filename+".pdf",()=>{
                window.location = Env.BASE_PDF+"/"+filename+".pdf";
            });
        }
    }
    
    render() {
        return (
            <div className="page page-inner ty p-md-5">
                <div className="container-fluid">
                    <div className="container p-0 text-center">
                        <h4 className="pb-3">Hi <span className="text-capitalize">{this.state.fullname}</span>, thank you for using Contracts.ph!</h4>
                        
                        <p>We also sent your custom <strong>{this.state.dn}</strong> to the email (<em>{this.state.destinationEmail}</em>) you provided.</p>

                        <h5 className="py-3">
                            <button className="btn btn-success btn-lg" onClick={this.download.bind(this)}>Click here if the download prompt doesn't start</button>
                        </h5>

                        <div className={`${this.state.recommend.length>0?`my-3 d-inline-block contract-message`:`d-none`}`}>
                            <p>
                                It seems that you created a contract that needs {
                                    this.state.recommend.map((el, i)=>{
                                        return(
                                            <span key={i}>{(i+1)!==this.state.recommend.length-1?` and `:``}<em><Link to={el.path} target="_blank" rel="noopener noreferrer">{el.form}</Link></em>{(i+1)<this.state.recommend.length && (i+1)!==this.state.recommend.length-1?`, `:``}</span>
                                        )
                                    })
                                }. Do you want to create one?
                            </p>
                            
                            <div className="list-group text-left">
                                {
                                    this.state.recommend.map((el, i)=>{
                                        return(                                         
                                            <Link key={i} to={el.path} className="list-group-item list-group-item-action flex-column align-items-start" target="_blank" rel="noopener noreferrer">
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1">{el.form}</h5>
                                                    <small className="text-danger">FREE</small>
                                                </div>
                                                <small>Click here to create one now!</small>
                                            </Link>                                           
                                        )
                                    })
                                }
                            </div>
                            
                        </div>
                        
                        <div className="contract-message">
                            <p>We are proud to offer a quality guarantee on all our legal documents and forms. Should you find any error in any of our documents, just send us an email at <a href={"mailto:"+Env.SUPPORT_EMAIL}>{Env.SUPPORT_EMAIL}</a> or <Link to="/contact">click here to contact us</Link> and we will make it right for you.</p>
                        </div>

                    </div>
                </div>
                <div className="text-center mt-5">
                    <Link to="/contracts" className="btn btn-secondary">Back to contract list</Link>
                </div>
                <p className="text-center mt-5"><small><em>PDF files will be automatically deleted after 24 hours.</em></small></p>
            </div>
        )
    }
}

export default withRouter(ThankYouContractForm);


// WEBPACK FOOTER //
// ./src/view/ThankYouContractForm.js